/* eslint-disable @typescript-eslint/no-explicit-any */

import { AuditTableCell } from "./audit-table-cell";
import { combineItemArrays } from "./combine-item-arrays";

export const AuditTableV2 = ({ data, parentKey }: any) => {
  const keys = Object.keys(data);

  const table = combineItemArrays(data, keys);
  return (
    <div className="overflow-auto">
      <div className="table w-full">
        <div className="table-row">
          {keys.map((key, index: number) => {
            return (
              <AuditTableCell
                isHeader={true}
                key={index}
                data={key}
                keyValue={key}
              />
            );
          })}
        </div>

        {table.map((item: any, index: number) => {
          return (
            <div className="table-row" key={index}>
              {keys.map((key, rowIndex: number) => {
                const value = item[key].text;
                const currentKey = `${key}.${item[key].row_number - 1}`;
                return (
                  <AuditTableCell
                    data={value}
                    key={rowIndex}
                    keyValue={currentKey}
                    parentKey={`${parentKey}.${currentKey}`}
                    feedback={item[key].feedback}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
